export default filename => filename.split('.').pop()
